const Grpc = () => import("@/components/test-infra-front/Grpc.vue");
const Rest = () => import("@/components/test-infra-front/Rest.vue");

export default [
  {
    path: "",
    name: "Grpc",
    component: Grpc,
  },
  {
    path: "rest",
    name: "Rest",
    component: Rest,
  },
];
